import React, { useState } from 'react';
import styled from 'styled-components';
import { FiChevronRight, FiChevronLeft } from 'react-icons/fi';
import { FaQuoteRight } from 'react-icons/fa';
import sixthSectionImage from '../../assets/sixthSectionImage.svg';
import image1 from '../../assets/pagination21.png';
import image2 from '../../assets/pagination22.png';
import image3 from '../../assets/pagination23.png';

export default function SixthSection() {
 const [isFirst, setIsFirst] = useState(true);
 return (
  <Container>
   <div className='bg'>
    <img src={sixthSectionImage} alt='background wallpaper' />
   </div>
   <Wrapper>
    <Button
     className='prev'
     background={isFirst ? '#8DC235' : '#6A6A6A'}
     onClick={() => {
      setIsFirst(true);
     }}
    >
     <FiChevronLeft />
    </Button>
    <Button
     className='next'
     background={!isFirst ? '#8DC235' : '#6A6A6A'}
     onClick={() => {
      setIsFirst(false);
     }}
    >
     <FiChevronRight />
    </Button>
    {isFirst ? <Card1 /> : <Card2 />}
   </Wrapper>
  </Container>
 );
}

function Card1() {
 return (
  <Carddiv>
   <Content>
    <div className='header'>Our Presence</div>
    <p>
     We Covers most of the major states in india like Kerala, Tamil nadu, Andra
     pradesh, Maharastra, Gujarat, Utrar Pradesh and union territory like
     Pondicherry
    </p>
    <Statsdiv>
     <Stats>
      <p>1M+</p>
      <p>tons of MSW processed</p>
     </Stats>
     <Stats>
      <p>10K+</p>
      <p>tons of RF recovere from MSW</p>
     </Stats>
    </Statsdiv>
   </Content>
   <Image src={image1} padding='3rem 2rem' />
  </Carddiv>
 );
}

function Card2() {
 return (
  <Carddiv>
   <Image src={image2} />
   <Content>
    <div className='header'>Carbon FOOTPRINT</div>
    <p>
     Till today Zigma has supplied more than 7.99 Lakh MT of RDF as a AFR which
     has saved has saved 7 Lakh MT of CO2, Emission and processed more than 60
     Lakh MT of MSW which as saved 4.14 Lakh of MT of CO2
    </p>
    <div>
     <Image src={image3} />
    </div>
   </Content>
  </Carddiv>
 );
}

const Container = styled.div`
 width: 100%;
 height: auto;
 position: relative;
 height: 60rem;
 z-index: 400;
 .bg {
  z-index: -100;
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background-color: #232323;
  img {
   width: 100%;
   height: 100%;
   object-fit: cover;
   z-index: -100;
  }
 }
 @media screen and (max-width: 600px) {
  height: 80rem;
 }
`;

const Wrapper = styled.div`
 width: 70%;
 height: 100%;
 margin: 0 auto 0rem auto;
 z-index: 1000;
 display: flex;
 padding-top: 12rem;
 align-items: center;
 position: relative;
 .prev {
  left: -10%;
 }
 .next {
  right: 20%;
 }
 @media screen and (max-width: 600px) {
  width: 100%;
  padding: 12rem 0 12rem 0;
  .prev {
   left: 5%;
  }
  .next {
   right: 5%;
  }
 }
`;

const Button = styled.button`
 position: absolute;
 top: 60%;
 transform: translateY(-50%);
 background-color: ${(props) => props.background};
 color: #000;
 width: 4rem;
 height: 4rem;
 display: grid;
 place-items: center;
 border-color: transparent;
 font-size: 2rem;
 border-radius: 50%;
 cursor: pointer;
 z-index: 2000;
 outline: none;
 border: none;
 svg {
  stroke-width: 3;
 }
 :focus {
  outline: none;
  border: none;
 }
`;

const Carddiv = styled.div`
 display: flex;
 gap: 2rem;
 z-index: 1000;
 width: 70%;
 background: linear-gradient(135deg, #f2f2f2 0%, #ffffff 100%);
 box-shadow: -2.50332px 2.50332px 5.00665px rgba(224, 224, 224, 0.2),
  2.50332px -2.50332px 5.00665px rgba(224, 224, 224, 0.2),
  -2.50332px -2.50332px 5.00665px rgba(255, 255, 255, 0.9),
  2.50332px 2.50332px 6.50864px rgba(224, 224, 224, 0.9),
  inset 0.500665px 0.500665px 1.00133px rgba(255, 255, 255, 0.3),
  inset -0.500665px -0.500665px 1.00133px rgba(224, 224, 224, 0.5);
 border-radius: 1rem;
 @media screen and (max-width: 600px) {
  margin: 0 auto;
  flex-direction: column-reverse;
  align-items: center;
 }
`;
const Image = styled.img`
 width: 40%;
 height: auto;
 object-fit: cover;
 padding: ${(props) => props.padding};
`;
const Content = styled.div`
 padding: 3rem 4rem;
 display: flex;
 flex-direction: column;
 gap: 2rem;
 justify-content: center;
 .header {
  font-weight: 500;
  font-size: 2rem;
  line-height: 3rem;
  text-align: center;
  text-transform: uppercase;
  color: #474747;
 }
 p {
  font-weight: 400;
  font-size: 1.5rem;
  line-height: 2rem;
  text-align: left;
  color: #474747;
 }
`;

const Statsdiv = styled.div`
 width: 80%;
 margin: 0 auto;
 display: flex;
 height: 7rem;

 > div {
  margin-right: 1rem;
 }
 > div:last-child {
  margin-right: 0rem;
 }
`;

const Stats = styled.div`
 flex: 1;
 padding: 0 1rem;
 height: 100%;
 display: flex;
 flex-direction: column;
 justify-content: center;
 align-items: center;
 border-radius: 1rem;
 padding: 0 1rem;
 > p:first-child {
  font-size: 2rem;
  color: #474747;
  text-align: center;
  line-height: 2rem;
  font-weight: 700;
 }
 > p:nth-child(2) {
  color: #3a3a3a;
  font-size: 1rem;
  text-align: center;
  line-height: 1rem;
  font-family: 400;
 }
 background: linear-gradient(135deg, #eaeaea 0%, #ffffff 100%);
 box-shadow: -8.37087px 8.37087px 16.7417px rgba(211, 211, 211, 0.2),
  8.37087px -8.37087px 16.7417px rgba(211, 211, 211, 0.2),
  -8.37087px -8.37087px 16.7417px rgba(255, 255, 255, 0.9),
  8.37087px 8.37087px 20.9272px rgba(211, 211, 211, 0.9),
  inset 0.380494px 0.380494px 0.760988px rgba(255, 255, 255, 0.3),
  inset -0.380494px -0.380494px 0.760988px rgba(211, 211, 211, 0.5);
`;
